import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 40vw;
	min-width: 300px;
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: auto 1fr;
	gap: 1.5rem;
	align-items: center;
	justify-content: flex-start;

	@media (max-width: 1000px) {
		width: 100%;
		min-width: 100%;
	}
`;

export const boxInputs = styled.div`
	width: 100%;
	max-height: 50vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	overflow: auto;
	gap: 1rem;
	padding-bottom: 2rem;
`;

export const twoInputs = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1.5rem;

	@media (max-width: 650px) {
		flex-direction: column;
	}
`;

export const boxImgs = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1.5rem;
	align-items: center;
	justify-content: center;

	@media (max-width: 1450px) {
		grid-template-columns: 1fr;
	}
`;

export const btns = styled.div`
	width: 100%;
	margin-top: 1rem;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;

	> button {
		all: unset;
		width: fit-content;
		text-align: center;
		border-radius: 5px;
		padding: 1rem 2rem;
		color: ${color.interface.white};
		font-size: 1.3rem;
		cursor: pointer;
	}
`;

export const save = styled.button`
	background-color: ${color.system.success} !important;
`;

export const cancel = styled.button`
	background-color: ${color.system.error} !important;
`;

export const checksBox = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1.5rem;
`;

export const title = styled.p`
	width: 100%;
	text-align: left;
	font-size: 1.75rem;
	font-family: nunito-bold;
	color: ${color.system.info};
`;
